export default __webpack_public_path__ + "static/presentacionVirtualGreenc-bf9982b9058cab9de0df6e437fd38b15.jpg";